module.exports = __webpack_public_path__ + "media/brands/lincoln-bd4aa911.png";